export const ProgressBarSteps = ({
  step,
  setStep,
}: {
  step: number;
  setStep: (step: number) => void;
}) => {
  const handleStepClick = (newStep: number) => {
    setStep(newStep);
  };

  return (
    <div className="w-full mb-8 md:mb-16">
      <div className="flex justify-between w-full mb-2.5">
        <button
          onClick={() => handleStepClick(0)}
          className={`text-xs md:text-sm font-semibold ${
            step >= 0 ? "text-[#c8ff00]" : "text-[#777777]"
          } transition-colors duration-300 cursor-pointer hover:text-[#c8ff00] focus:outline-none bg-transparent border-none py-1 px-1`}
        >
          PROFILE PICTURE
        </button>
        <button
          onClick={() => handleStepClick(1)}
          className={`text-xs md:text-sm font-semibold ${
            step >= 1 ? "text-[#c8ff00]" : "text-[#777777]"
          } transition-colors duration-300 cursor-pointer hover:text-[#c8ff00] focus:outline-none bg-transparent border-none py-1 px-1`}
        >
          AGENT INFO
        </button>
        <button
          onClick={() => handleStepClick(2)}
          className={`text-xs md:text-sm font-semibold ${
            step >= 2 ? "text-[#c8ff00]" : "text-[#777777]"
          } transition-colors duration-300 cursor-pointer hover:text-[#c8ff00] focus:outline-none bg-transparent border-none py-1 px-1`}
        >
          CORE IDENTITY
        </button>
      </div>

      <div className="relative h-4 flex items-center">
        <div className="absolute w-full h-0.5 bg-[#444444] top-1/2 transform -translate-y-1/2"></div>

        <div
          className="absolute h-0.5 bg-[#c8ff00] top-1/2 transform -translate-y-1/2 transition-all duration-300"
          style={{
            width:
              step === 0
                ? "0%"
                : step === 0.5
                  ? "16.5%"
                  : step === 1
                    ? "50%"
                    : step === 1.5
                      ? "75%"
                      : step === 2
                        ? "100%"
                        : "0%",
          }}
        ></div>

        <div className="absolute w-full flex justify-between">
          <button
            onClick={() => handleStepClick(0)}
            className={`w-3 h-3 md:w-4 md:h-4 rounded-full ${step >= 0 ? "bg-[#c8ff00]" : "bg-[#444444]"} transition-colors duration-300 cursor-pointer focus:outline-none`}
          ></button>

          <button
            onClick={() => handleStepClick(1)}
            className={`w-3 h-3 md:w-4 md:h-4 rounded-full ${step >= 1 ? "bg-[#c8ff00]" : "bg-[#444444]"} transition-colors duration-300 cursor-pointer focus:outline-none`}
          ></button>

          <button
            onClick={() => handleStepClick(2)}
            className={`w-3 h-3 md:w-4 md:h-4 rounded-full ${step >= 2 ? "bg-[#c8ff00]" : "bg-[#444444]"} transition-colors duration-300 cursor-pointer focus:outline-none`}
          ></button>
        </div>
      </div>
    </div>
  );
};
